export default "__VITE_ASSET__T7GCdqq3__"